import { forwardRef } from 'react';

import { isSvpAsset, isSvpCategory } from '../../../modules/helpers';
import { getPath, routeNames } from '../../../shared/helpers/routes';
import { isDocumentary } from '../../../player/playerAssetHelpers';

import { MobileSplash } from './MobileSplash/MobileSplash';
import { MobileSlider } from './MobileSlider/MobileSlider';

import type { Vendor } from '../../../types';
import type { SvpCategoryAdditional } from '@vgtv/api-client/lib/svp_category';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';

import * as styles from './MobileCarousel.module.scss';

interface MobileCarouselProps {
  currentItem: SvpAssetAdditional | SvpCategoryAdditional;
  items: (SvpAssetAdditional | SvpCategoryAdditional)[];
  onThumbnailClick: () => void;
  vendor: Vendor;
}

export const MobileCarousel = forwardRef<HTMLDivElement, MobileCarouselProps>(
  ({ currentItem, items, onThumbnailClick, vendor }, ref) => {
    let url: string;

    if (isSvpCategory(currentItem)) {
      url = getPath(routeNames.category, {
        vendor,
        category: currentItem,
      });
    } else if (isSvpAsset(currentItem) && isDocumentary(currentItem)) {
      url = getPath(routeNames.asset, {
        asset: currentItem,
      });
    } else {
      const category = currentItem.category;

      url = getPath(routeNames.category, {
        vendor,
        category,
      });
    }

    return (
      <div className={styles.mobileCarouselWrapper} ref={ref}>
        <MobileSplash
          item={currentItem}
          url={url}
          className={styles.mobileSplash}
        />
        <div className={styles.slider}>
          <MobileSlider
            onClick={onThumbnailClick}
            items={items}
            vendor={vendor}
          />
        </div>
      </div>
    );
  }
);
MobileCarousel.displayName = 'MobileCarousel';
